import { SpinResponse } from '@cgs/data-access';
import { Action, Container } from '@cgs/wge';
import { StopAfterSpinActionWithIconReplacment } from '../../reels_engine/actions/stop_after_spin_action_with_icon_replacment';
import {
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  IGameStateMachineProvider,
} from '../../reels_engine/game_components_providers/i_game_state_machine_provider';
import { IReelsEngineProvider } from '../../reels_engine/game_components_providers/i_reels_engine_provider';
import { AbstractGameConfig } from '../../reels_engine/game_config/abstract_game_config';
import { ReelsEngine } from '../../reels_engine/reels_engine';
import { SlotStopActionWithReplacedIcons } from '../../reels_engine/slot_stop_action_with_replaced_icons';
import { GameStateMachine } from '../../reels_engine/state_machine/game-state-machine';
import {
  T_IGameConfigProvider,
  T_ISlotGameEngineProvider,
  T_RegularSpinsSoundModelComponent,
} from '../../type_definitions';
import { IStopSlotActionProvider } from './i_stop_slot_action_provider';
import { IGameConfigProvider } from './interfaces/i_game_config_provider';
import { RegularSpinsSoundModelComponent } from './regular_spins_sound_model_component';
import { RegularSpinsSoundModel } from '../../reels_engine/reels_sound_model';

enum SpinMode {
  Spin,
  ReSpin,
}

export class SlotStopActionWithReplacedIconsProvider implements IStopSlotActionProvider {
  private readonly _container: Container;
  private readonly _regularSpinSoundModel: RegularSpinsSoundModel;
  private readonly _stateMachine: GameStateMachine<SpinResponse>;
  private readonly _config: AbstractGameConfig;
  private readonly _uniqueReelsSymbols: number[] | null;

  private readonly _stopReelsSoundImmediately: boolean;
  private readonly _useSounds: boolean;
  private readonly _reelsEngine: ReelsEngine;

  constructor(
    container: Container,
    stopReelsSoundImmediately: boolean,
    useSounds: boolean = true,
    uniqueReelsSymbols: number[] | null = null
  ) {
    this._container = container;
    this._stopReelsSoundImmediately = stopReelsSoundImmediately;
    this._useSounds = useSounds;
    this._uniqueReelsSymbols = uniqueReelsSymbols;

    this._regularSpinSoundModel = this._container.resolve<RegularSpinsSoundModelComponent>(
      T_RegularSpinsSoundModelComponent
    ).regularSpinSoundModel;
    this._stateMachine = this._container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;
    this._config = this._container.resolve<IGameConfigProvider>(T_IGameConfigProvider).gameConfig;
    this._reelsEngine =
      this._container.resolve<IReelsEngineProvider>(T_ISlotGameEngineProvider).reelsEngine;
  }

  getStopSlotAction(spinMode: SpinMode): Action {
    switch (spinMode) {
      case SpinMode.Spin:
        return new SlotStopActionWithReplacedIcons(
          this._container,
          this._reelsEngine,
          this._stateMachine.curResponse.viewReels,
          this._stateMachine.curResponse.winLines,
          this._stateMachine.curResponse.winPositions,
          this._config.regularSpinConfig,
          this._regularSpinSoundModel,
          this._stopReelsSoundImmediately,
          this._useSounds,
          this._uniqueReelsSymbols || []
        );
      case SpinMode.ReSpin:
        return new StopAfterSpinActionWithIconReplacment(
          this._container,
          this._reelsEngine,
          this._config.regularSpinConfig,
          this._stateMachine.curResponse,
          this._regularSpinSoundModel,
          this._stopReelsSoundImmediately,
          this._useSounds,
          this._uniqueReelsSymbols
        );
      default:
        return new SlotStopActionWithReplacedIcons(
          this._container,
          this._reelsEngine,
          this._stateMachine.curResponse.viewReels,
          this._stateMachine.curResponse.winLines,
          this._stateMachine.curResponse.winPositions,
          this._config.regularSpinConfig,
          this._regularSpinSoundModel,
          this._stopReelsSoundImmediately,
          this._useSounds,
          this._uniqueReelsSymbols || []
        );
    }
  }
}
